import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '../../widgets/navigation';
import { LoginPage, DashboardPage, UsersPage, RolesPage } from '../../pages';
import { ProtectedRoute } from '../../shared/ui/protected-route';
import { PermissionGuard } from '../../shared/ui/permission-guard';
import { useAuthStore } from '../store/auth-store';
import { UnauthorizedPage } from '../../pages/unauthorized';
import { NotFoundPage } from '../../pages/not-found';

/**
 * Main application routes configuration
 */
export const AppRoutes: React.FC = () => {
  const { checkAuth } = useAuthStore();

  // Check authentication on app start
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/auth/login" 
        element={
          <ProtectedRoute requireAuth={false}>
            <LoginPage />
          </ProtectedRoute>
        } 
      />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      
      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AppLayout>
              <DashboardPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <PermissionGuard 
              permission="users:read"
              fallback={<Navigate to="/unauthorized" replace />}
            >
              <AppLayout>
                <UsersPage />
              </AppLayout>
            </PermissionGuard>
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/roles"
        element={
          <ProtectedRoute>
            <PermissionGuard 
              permission="roles:read"
              fallback={<Navigate to="/unauthorized" replace />}
            >
              <AppLayout>
                <RolesPage />
              </AppLayout>
            </PermissionGuard>
          </ProtectedRoute>
        }
      />

      {/* Default redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* 404 page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};